export class School {
    constructor(inep, name) {
        this.inep = inep
        this.name = name
        this.examApplicationCity = undefined
        this.examTotalAmount = undefined
        this.studentCount = undefined
        this.paymentDone = false
    }
}